import React from 'react';
import { Chip } from '@mui/material';
import { blue, grey, red, green, deepOrange } from '@mui/material/colors';
import { useUpdate, useNotify, Confirm } from 'react-admin';
import { useState } from 'react';

interface IData {
    [key: string]: any;
}

const Tags: React.FC<IData> = (props) => {
    const [open, setOpen] = useState(false);//react-admin confirm
    const [newTags, setNewTags] = useState('');
    const [handleUpdate] = useUpdate();
    const notify = useNotify();
    const hanldeDelete = (_, value) => {
        props.setCommon(prev => ({ ...prev, quickDeleteTag: true }));//for handle editor cell
        setNewTags(removeTags(props.value, value));
        setOpen(true);
    };

    const removeTags = (oldTag, tag) => {
    // Remove the commas from the start and end of the string
        oldTag = oldTag.replace(/^,|,$/g, '');
        // Split the string by commas and filter out the unwanted tag
        const tags = oldTag.split(',').filter((t: any) => t !== tag);
        // Join the filtered tags with commas
        return tags.join(',');
    };

    const handleConfirm = () => {
        let event = props.data;
        event.tags = newTags;
        handleUpdate('EventMatcher', { id: event.id, data: event }, {
            onSuccess: (_result) => {
                notify('Update successfully', { type: 'success', autoHideDuration: 2000 });
                UpdateGrid(props);
                props.api.stopEditing();
                props.reloadPage();
            },
            onError: (error) => {
                notify(`Update error: ${error.message}`, { type: 'error', autoHideDuration: 5000 });
                props.api.stopEditing();
            },
        });
        props.setCommon(prev => ({ ...prev, quickDeleteTag: false }));//for handle editor cell
        setOpen(false);
        function UpdateGrid (props) {
            props.data = event;
            props.api.refreshCells({
                columns: ['tags'],
                rowNodes: [props.node],
                force: true
            });
        }
    };

    let tags = props.data.tags.split(',').filter((value: any) => value !== '');
    const isIgnoredInQueue = props.data.queueUploadStatus === -1; // If the event is ignored in the queue, we add the "ignored" tag to the list of tags to be displayed
    tags = isIgnoredInQueue ? [...tags, 'ignored'] : tags;

    const getStyles = (tagName) => {
        switch (tagName.trim()) {
            case 'high value':
                return green[500];
            case 'low value':
                return red[600];
            case 'support ticket':
                return blue[500];
            case 'skip':
            case 'unmapped':
            case 'manual review':
                return grey[500];
            default:
                return deepOrange[400];
        }
    };
    const getDeleteTag = () => {
        let currentTag = props.data.tags;
        return currentTag.split(',').find((x: any) => x && !newTags.includes(x)) || '';
    };
    return (
        <div style={{ marginBottom: '6px' }}>
            {tags.map((tag) => (
                <Chip
                    size="small"
                    style={{
                        backgroundColor: getStyles(tag.toString().toLowerCase()),
                        fontSize: '12px',
                        '& .MuiChip-label': {
                            padding: '0 6px'
                        } }}
                    onDelete={(e) => hanldeDelete(e, tag)}
                    key={tag} label={tag} />
            ))}
            <Confirm isOpen={open} title={`Delete "${getDeleteTag()}" Tag`} content='Are you sure want to delete this tag?' onConfirm={handleConfirm}
                onClose={() => {
                    props.setCommon(prev => ({ ...prev, quickDeleteTag: false }));//for handle editor cell
                    setOpen(false);
                }}
            />
        </div>
    );
};


export default Tags;
